// extracted by mini-css-extract-plugin
export default {"wrapper":"kng_LTnJ1yu7etjvpQmZ","title":"lGxsYIVnaHotjCpeFApb","text":"DpM6rg20x4But9IRpzVZ","input_wrapper":"DAXrZnMxwJBMZThcKKXe"};